import {useCallback, useEffect, useRef} from 'react'

import type {Refetchable} from '../utils/refetchable'

// initiate should be memoized with useCallback
export function useRefetch(
  fetch: (args: {inBackground?: boolean; forceRefetch?: boolean}) => Refetchable | null,
) {
  const unsubscribe = useRef<(() => void) | undefined>()

  useEffect(() => {
    const result = fetch({
      inBackground: false,
      forceRefetch: false,
    })

    unsubscribe.current?.()
    unsubscribe.current = result?.unsubscribe

    return () => {
      unsubscribe.current?.()
    }
  }, [fetch])

  return useCallback(() => {
    const result = fetch({
      inBackground: true,
      forceRefetch: true,
    })

    unsubscribe.current?.()
    unsubscribe.current = result?.unsubscribe

    return result
  }, [fetch])
}
